export default [
    {
        name: 'Select Tool',
        displayName: 'Select',
        icon: 'fas fa-bullseye-pointer',
        tooltip: 'Select - Click a feature to select it.',
        description: 'Click a geo record to select it. Right click to modify geo record.',
        mode: 'simple_select',
    },
    {
        name: 'Multi Select Tool',
        displayName: 'Multi Select',
        icon: 'fas fa-object-ungroup',
        tooltip:
            'Multi Select Tool - Click a feature to select it and then click another feature to select it.',
        description: 'Select multiple geo records to translate.',
        mode: 'simple_select',
    },
    {
        name: 'Location Tool',
        displayName: 'Location',
        icon: 'fas fa-map',
        mode: 'simple_select',
    },
    {
        name: 'Delete Tool',
        displayName: 'Delete',
        icon: 'fas fa-trash',
        description: 'Click a geo record to delete it.',
        mode: 'simple_select',
    },
];
